import React, { Component } from "react";
// import download from 'downloadjs';
import { Redirect } from "react-router-dom";
import Tooltip from "../Tooltip";
import AbsoluteLabel from "../AbsoluteLabel";
import {
  TextField,
  RaisedButton,
  Checkbox,
  RadioButton,
  RadioButtonGroup
} from "material-ui";
import LigandSection from "./ligand_section";
import PdbSection from "./pdb_section";
import config from "../../config.json";

import "./style.css";

export default class SubmitForm extends Component {
  constructor(props) {
    super(props);
    this.defaultErros = {
      error: ""
    };
    this.defaultState = {
      option: "1",
      email: "",
      affiliation: "",
      jobName: "",
      pdbid: "",
      upload: "",
      iterations: 500,
      chains: "first",
      optimize_protein: true,
      keep_water: false,
      add_hydrogens: true,
      ligand_charge: "0",
      ligand_id: "ANP",
      s_ligand_charge: "0",
      s_ligand_charge_check: false,
      ligand_hydrogen_atoms: false,
      keep_ligand: false,
      upload_ligand: ""
    };
    this.state = { ...this.defaultState, errors: { ...this.defaultErros } };
  }

  handleChange(event, elementValue = undefined) {
    const { name, value, type } = event.target;
    console.log(name, value, elementValue);
    if (type === "checkbox") {
      this.setState({ [name]: elementValue });
    } else {
      this.setState({ [name]: value });
    }

    if (name === "ligand_hydrogen_atoms" && elementValue) {
      this.setState({ s_ligand_charge_check: elementValue });
    }
  }

  resetForm() {
    this.setState({ ...this.defaultState, errors: { ...this.defaultErros } });
  }

  validateForm() {
    const form = this.state;
    let status = true;
    if (form.option === "1") {
      if (!form.upload.match(/(\.pqrs$)|(\.PQRS$)/)) {
        this.setState({
          errors: {
            ...this.state.errors,
            error: "Please select a .pqrs file"
          }
        });
        status = false;
      }
    }

    if (form.option === "2") {
      if (!form.upload.match(/(\.pdb)|(\.PDB$)/)) {
        this.setState({
          errors: { ...this.state.errors, error: "Please select a .pdb file" }
        });
        status = false;
      }
    }

    if (form.option === "3") {
      if (!form.upload.match(/(\.pqr)|(\.PQR$)/)) {
        this.setState({
          errors: { ...this.state.errors, error: "Please select a .pqr file" }
        });
        status = false;
      }
    }

    if (form.option === "4") {
      if (form.pdbid.length <= 0) {
        this.setState({
          errors: { ...this.state.errors, pdbid: "PDB id cannot be empty" }
        });
        status = false;
      }
    }

    if (!form.iterations.toString().match(/^[0-9]+$/)) {
      this.setState({
        errors: {
          ...this.state.errors,
          iterations: "Iterations have to be integer"
        }
      });
      status = false;
    }

    const iterations = parseInt(form.iterations, 10);
    if (iterations <= 0 || iterations > 5000) {
      this.setState({
        errors: {
          ...this.state.errors,
          iterations: "Iterations have to be in range from 1 to 5000"
        }
      });
      status = false;
    }

    if (
      form.separate_ligand &&
      !form.upload_ligand.match(/(\.mol2)|(\.MOL2$)/)
    ) {
      this.setState({
        errors: { ...this.state.errors, error: "Please select a .mol2 file" }
      });
      status = false;
    }

    return status;
  }

  submitForm() {
    // console.log(this.state);
    this.setState({ errors: {} }, () => {
      if (this.validateForm()) {
        const inputMain = document.querySelector(
          "input[type=file][name=upload]"
        );
        const inputLigand = document.querySelector(
          "input[type=file][name=upload_ligand]"
        );
        const formData = new FormData();

        if (this.state.option === "4" || this.state.option === "2") {
          // PDB file
          formData.append("chains", this.state.chains);
          formData.append("optimize_protein", this.state.optimize_protein);
          formData.append("keep_water", this.state.keep_water);
        }

        if (this.state.keep_ligand) {
          formData.append("keep_ligand", this.state.keep_ligand);
          formData.append("ligand_id", this.state.ligand_id);
          formData.append("add_hydrogens", this.state.add_hydrogens);
          formData.append("ligand_charge", this.state.ligand_charge);
        }

        if (this.state.separate_ligand) {
          formData.append("separate_ligand", this.state.separate_ligand);
          formData.append(
            "ligand_hydrogen_atoms",
            this.state.ligand_hydrogen_atoms
          );
          formData.append("upload_ligand", inputLigand.files[0]);
          if (this.state.s_ligand_charge_check) {
            formData.append("s_ligand_charge", this.state.s_ligand_charge);
          } else {
            formData.append("s_ligand_charge", "X");
          }
        } else {
          formData.append("s_ligand_charge", "X");
        }

        if (this.state.option === "4") {
          formData.append("pdbid", this.state.pdbid);
        } else {
          formData.append("upload", inputMain.files[0]);
        }

        formData.append("option", this.state.option);
        formData.append("email", this.state.email);
        formData.append("affiliation", this.state.affiliation);
        formData.append("jobName", this.state.jobName);
        formData.append("iterations", this.state.iterations);
        fetch(config.submitEndpoint, {
          method: "POST",
          body: formData
        })
          .then(function(response) {
            return response.json();
          })
          .then(json => {
            console.log(json);
            if (json.id) this.setState({ responseId: json.id });
            if (json.error) {
              this.setState({
                errors: { ...this.state.errors, error: json.message }
              });
            }
          })
          .catch(function(e) {
            console.log("Error", e);
          });
        // .then(function(response) {
        //   return response.blob();
        // })
        // .then(function(blob) {
        //   download(blob, 'config.gsl');
        // });
      }
    });
  }

  render() {
    // console.log(this.state);
    const filetypes =
      this.state.option === "1"
        ? ".pqrs"
        : this.state.option === "2" ? ".pdb" : ".pqr";
    return (
      <form className={"submit-form"} action="">
        <div className={"black-label"}>
          Job name:{" "}
          <Tooltip
            id={"job-tooltip"}
            label={"If not provided, a random name will be assigned."}
          />
        </div>
        <TextField
          hintText="Job name (optional)"
          value={this.state.jobName}
          name={"jobName"}
          onChange={e => this.handleChange(e)}
          errorText={this.state.errors.jobName}
        />
        <br />
        <div className={"black-label"}>
          Email address:{" "}
          <Tooltip
            id={"email-tooltip"}
            label={
              <span>
                Your results will be sent to this email. Your email address will
                not be stored afterwards. <br />
                You can also download the results directly from the server.
              </span>
            }
          />
        </div>
        <TextField
          name={"email"}
          hintText="Email (optional)"
          value={this.state.email}
          onChange={e => this.handleChange(e)}
          errorText={this.state.errors.email}
        />
        <br />
        <div className={"black-label"}>
          Affiliation:{" "}
          <Tooltip
            id={"affiliation-tooltip"}
            label={
              <span>
                Please provide your affiliation, as this will help us document
                the server use in order to receive support for its maintenance.<br />
                Note that we will not store your personal data, such as email
                address.
              </span>
            }
          />
        </div>
        <TextField
          name={"affiliation"}
          hintText="Affiliation (optional)"
          value={this.state.affiliation}
          onChange={e => this.handleChange(e)}
        />
        <br />
        <br />
        <h3>Protein setup</h3>
        <p>Select input format for protein structure:</p>
        <div className={"options"}>
          <div style={{ width: "25%", minWidth: "390px" }}>
            <RadioButtonGroup
              name={"option"}
              onChange={e => this.handleChange(e)}
              valueSelected={this.state.option}
              defaultSelected={this.state.option}
            >
              <RadioButton
                value="2"
                label={
                  <AbsoluteLabel>
                    PDB file
                    <Tooltip
                      id={"pdb-file-tooltip"}
                      label={
                        <span>
                          Standard PDB file format. <br />Note: only “ATOM”
                          lines will be processed by default.
                        </span>
                      }
                    />
                  </AbsoluteLabel>
                }
              />
              <RadioButton
                value="4"
                label={
                  <AbsoluteLabel>
                    get PDB id
                    <Tooltip
                      id={"pdb-id-file-tooltip"}
                      label="Provide a four letter PDB id to download from rcsb.org."
                    />
                  </AbsoluteLabel>
                }
              />
              <RadioButton
                value="3"
                label={
                  <AbsoluteLabel>
                    PQR file
                    <Tooltip
                      id={"pqr-file-tooltip"}
                      label={
                        <span>
                          A PDB file with numbers in temperature and occupancy
                          columns<br />
                          replaced by atomic partial charge and radius,
                          respectively.
                        </span>
                      }
                    />
                  </AbsoluteLabel>
                }
              />
              <RadioButton
                value="1"
                label={
                  <AbsoluteLabel>
                    PQRS file
                    <Tooltip
                      id={"pqrs-file-tooltip"}
                      label={
                        <span>
                          A pqr file with one additional column for atomic sigma
                          parameters<br />
                          of Lennard Jones potential.
                        </span>
                      }
                    />
                  </AbsoluteLabel>
                }
              />
            </RadioButtonGroup>
          </div>

          {this.state.option === "4" ? (
            <TextField
              name={"pdbid"}
              hintText="provide PDB id"
              value={this.state.pdbid}
              onChange={e => this.handleChange(e)}
              errorText={this.state.errors.pdbid}
            />
          ) : (
            <RaisedButton
              label={
                this.state.upload === ""
                  ? "Add file"
                  : `Selected (${this.state.upload.replace(/^.*[\\/]/, "")})`
              }
              containerElement="label"
            >
              <input
                onChange={e => this.handleChange(e)}
                name={"upload"}
                type="file"
                style={{ display: "none" }}
                accept={filetypes}
              />
            </RaisedButton>
          )}
        </div>
        {this.state.option === "4" || this.state.option === "2" ? (
          <PdbSection
            state={this.state}
            handleChange={(e, v = undefined) => this.handleChange(e, v)}
          />
        ) : (
          ""
        )}

        <h3>Ligand setup</h3>

        <Checkbox
          name={"keep_ligand"}
          checked={this.state.keep_ligand}
          onCheck={(e, v) => this.handleChange(e, v)}
          label={
            <AbsoluteLabel>
              Keep ligand structure from the PDB file
              <Tooltip
                id={"keep-ligand-tooltip"}
                label={
                  <span>
                    Keep atoms from HETATM PDB section for molecule/residue of
                    specified ID.<br />
                    We will attempt to add hydrogens and calculate partial
                    charges for you.
                  </span>
                }
              />
            </AbsoluteLabel>
          }
          errorText={this.state.errors.keep_ligand}
        />
        <LigandSection
          handleChange={(e, v = undefined) => this.handleChange(e, v)}
          state={this.state}
        />
        <h3>Run setup</h3>
        <div className={"black-label"}>
          Number of iterations:{" "}
          <Tooltip
            id={"iterations-tooltip"}
            label={
              <span>
                Use a number between 100 and 1000. <br />
                More iterations give better results, but increase the waiting
                time.
              </span>
            }
          />
        </div>
        <TextField
          name={"iterations"}
          hintText="500"
          value={this.state.iterations}
          onChange={e => this.handleChange(e)}
          errorText={this.state.errors.iterations}
        />

        <br />
        <span className={"error"}>{this.state.errors.error}</span>
        <br />
        <RaisedButton
          onClick={() => this.submitForm()}
          label={"Submit!"}
          primary
          style={{ marginRight: "8px" }}
        />
        <RaisedButton
          label={"Reset form"}
          onClick={() => this.resetForm()}
          secondary
        />
        {this.state.responseId ? (
          <Redirect to={"/status/" + this.state.responseId} />
        ) : (
          ""
        )}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SubmitForm/index.js